// extracted by mini-css-extract-plugin
export default {"container":"Screening_container__YotOl","heading":"Screening_heading__iz-pN","screeningHeader":"Screening_screeningHeader__RCYWw"};